import posthog from 'posthog-js'
import React from 'react'

export const onClientEntry = () => {
    const apiKey = process.env.GATSBY_POSTHOG_API_KEY
    const apiHost = process.env.GATSBY_POSTHOG_API_HOST || 'https://app.posthog.com'

    if (apiKey) {
        posthog.init(apiKey, {
            api_host: apiHost,
            // 'localStorage' is generally preferred for SPA/modern web apps
            persistence: 'localStorage',
            // Autocapture tracks clicks, inputs, and form submissions automatically
            autocapture: true,
            capture_pageview: true,
        })
    } else {
        console.warn('PostHog API Key not found. Analytics will not be tracked.')
    }
}
